import { render, staticRenderFns } from "./productApprove-detail.vue?vue&type=template&id=5a2258d4&scoped=true"
import script from "./productApprove-detail.vue?vue&type=script&lang=js"
export * from "./productApprove-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2258d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a2258d4')) {
      api.createRecord('5a2258d4', component.options)
    } else {
      api.reload('5a2258d4', component.options)
    }
    module.hot.accept("./productApprove-detail.vue?vue&type=template&id=5a2258d4&scoped=true", function () {
      api.rerender('5a2258d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/product-management/productApprove-management/productApprove-detail.vue"
export default component.exports